<div [ngClass]="{ card: !modalMode }">
  @if (!modalMode) {
    <div class="card-header">
      <h1>
        {{ title$ | async | translate }}
      </h1>
    </div>
  }

  <div class="card-body">
    @if (modalMode) {
      <div class="row margin-bottom-md">
        <form [formGroup]="form">
          <ds-input [label]="'label_workspace' | translate" required="true" data-test-id="workspace-filter">
            <select
              class="mw-100"
              ds-input-field
              data-test-id="workspace-filter-select"
              [formControlName]="$digitalProperty.workspaceId"
            >
              <option [ngValue]="null" disabled>{{ 'select_an_option' | translate }}</option>
              @for (workspace of availableWorkspaces$ | async; track workspace[$workspace._id]) {
                <option [ngValue]="workspace[$workspace._id]">{{ workspace[$workspace.name] }}</option>
              }
            </select>
          </ds-input>
        </form>
      </div>
    }

    <div class="row">
      <div class="col-12">
        @if (digitalAssetFormUpdateEnabled()) {
          <div class="label margin-bottom-md" id="header-number-of-digital-properties">
            {{ 'label_number_of_digital_properties' | translate }}
          </div>
        } @else {
          <h2 class="margin-bottom-md" id="header-number-of-digital-properties">
            {{ 'label_number_of_digital_properties' | translate }}
          </h2>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div
          class="d-flex flex-column align-items-start btn-group"
          role="radiogroup"
          aria-labelledby="header-number-of-digital-properties"
        >
          <label class="clean-button btn border-0">
            <input
              type="radio"
              data-test-id="single-digital-property"
              [(ngModel)]="singleDigitalProperty"
              [value]="true"
              [attr.aria-label]="digitalAssetFormUpdateEnabled() ? ('label_one_digital_asset' | translate) : null"
            />
            {{ 'label_one' | translate }}
          </label>
          <label class="clean-button btn border-0">
            <input
              type="radio"
              data-test-id="multiple-digital-properties"
              [(ngModel)]="singleDigitalProperty"
              [value]="false"
              [attr.aria-label]="digitalAssetFormUpdateEnabled() ? ('label_multiple_digital_assets' | translate) : null"
            />
            {{ 'label_multiple' | translate }}
          </label>
        </div>
      </div>
    </div>

    @if (singleDigitalProperty) {
      <app-add-single-digital-property
        [homeLink]="homeLink"
        [tenantId]="tenantId"
        [modalMode]="modalMode"
        [selectedWorkspaceId]="selectedWorkspaceId"
        (cancelled)="onCancel()"
        (save)="onSave($event)"
      >
      </app-add-single-digital-property>
    }

    @if (singleDigitalProperty === false) {
      <app-add-multiple-digital-property
        [homeLink]="homeLink"
        [modalMode]="modalMode"
        [selectedWorkspaceId]="selectedWorkspaceId"
        (cancelled)="onCancel()"
        (save)="onSave()"
      >
      </app-add-multiple-digital-property>
    }
  </div>
</div>
